<template>
  <van-dialog
    :className="[
      'trial-tip-dialog',
      {
        'isIOS-wx-mini': isIOSWxMini,
      },
    ]"
    title="温馨提示"
    :value="value"
    @input="$emit('input', $event)"
    :confirmButtonText="'购买会员'"
    :cancelButtonText="isIOSWxMini ? '我知道了' : '取消'"
    :showConfirmButton="!isIOSWxMini"
    :showCancelButton="true"
    @confirm="onConfirm"
  >
    <div class="tip">
      你当前为会员<span class="red">【体验套餐】</span
      >权益，无法使用正式会员全部声音，【{{
        speaker ? speaker.name : ""
      }}】为正式会员专属声音，成为正式会员后享受海量声音使用权限
    </div>
  </van-dialog>
</template>
<script>
import { judgeDeviceType } from "@/utils/device";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    speaker: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isIOSWxMini: judgeDeviceType.isIOSWxMini,
    };
  },
  methods: {
    onConfirm() {
      this.$emit("buy-vip");
    },
  },
};
</script>
<style lang="less" scoped>
.tip {
  padding: 24px 41px;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #333333;
  line-height: 36px;
  .red {
    color: #e02020;
  }
}
</style>
<style lang="less">
.trial-tip-dialog {
  left: 67px;
  right: 67px;
  width: auto;
  top: 50%;
  transform: translateY(-50%);
  .van-dialog__header {
    padding-top: 56px;
    font-size: 30px;
    font-weight: 600;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #333333;
    line-height: 30px;
  }
  .van-dialog__footer {
    padding: 0 56px;
    margin-bottom: 40px;
    button {
      width: 224px;
      height: 76px;
      background: #ebebeb;
      border-radius: 38px;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333 !important;
      line-height: 42px;
    }
    .van-dialog__confirm {
      background: linear-gradient(153deg, #fff1d4 0%, #d19338 100%) !important;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #8d510a !important;
    }
  }
  &.isIOS-wx-mini {
    .van-dialog__footer {
      justify-content: center;
    }
  }
}
</style>
